import { type OrganizationManager } from "@entities";
import { Button } from "@mui/material";
import { BaseRoles } from "@shared/Roles";
import { type ColumnProps } from "@shared/frontend/hyper-table/types";
import { type CoreRow } from "@tanstack/react-table";
import PhoneNumberCell from "../PhoneNumberCell";

export const getColumns = (setSelectedManger: React.Dispatch<React.SetStateAction<OrganizationManager | undefined>>): ColumnProps<OrganizationManager>[] => {
  return [
    {
      field: "name",
      enableSorting: true,
    },
    {
      field: "phoneNumber",
      cell: ({ row }) => (
        <PhoneNumberCell phoneNumber={row.original.phoneNumber || ""} />
      ),
      preventRowClick: true,
    },
    {
      field: "voicenterExtension",
      caption: "Voicenter - רגל 1 (phone)",
      cell: ({ row }) => row.original.voicenterExtension?.trim() || "-",
    },
    {
      field: "roles",
      cell: ({ row }: { row: CoreRow<OrganizationManager>; }) => (
        <p>
          {row.original.roles.includes(BaseRoles.Manager)
            ? "מנהל"
            : row.original.roles.includes(BaseRoles.Admin)
              ? "מנהל כללי"
              : "מנהל מערכת"}
        </p>
      ),
    },
    { field: "role" },
    {
      field: "teams",
      enableSorting: true,
      cell: ({ row }: { row: CoreRow<OrganizationManager>; }) => (
        <><p>
          {row.original.teams?.length
            ? row.original.teams
              ?.map((team) => team.team?.name)
              .filter((team) => team)
              .join(", ")
            : "-"}
        </p>
        </>
      ),
    },
  ];
};
